var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgOvalCopy = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "160px",
    height: "160px",
    viewBox: "0 0 160 160",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "8D0A889C-7086-4E19-9E72-1C59B2685E2D") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Wireframes-2.0",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "15.0-Profile",
    transform: "translate(-213.000000, -244.000000)",
    fill: "#FFFFFF",
    stroke: "#4A4A4A",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy",
    cx: 293,
    cy: 324,
    r: 79
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgOvalCopy);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ovalCopy.49fbbf030fe84aa8ede992c79368e2f3.svg";